import { HelmetProvider } from "react-helmet-async";
import { Suspense } from "react";
import { useRoutes } from "react-router-dom";
import "./App.css";
import { ImageElement } from "components";
import { routes } from "./route";

function RouteLayout({ path }) {
  const element = useRoutes(path);
  return element;
}

function App() {
  return (
    <>
      <HelmetProvider>
        <Suspense
          fallback={
            <div className="mainLoader">
              <div className="loaderImg d-flex">
                <ImageElement
                  source="loader-icon.svg"
                  className="loaderIcon"
                  alt="logo"
                />
                <ImageElement
                  source="loader-text.svg"
                  className="loader"
                  alt="logo"
                />
              </div>
            </div>
          }
        >
          <RouteLayout path={routes()} />
        </Suspense>
      </HelmetProvider>
    </>
  );
}

export default App;
